import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { firestore } from "../../db/config";
import "./chat.css";
import SendImage from "./send.png";
import firebase from "firebase";
import moment from "moment";
import RenderMessage from "./renderMessage";
export default function Chat() {
  //   useEffect(() => {
  //     firestore
  //       .collection("deposit")
  //       .get()
  //       .then((data) => {
  //         const getDeposit = data.docs.map((data) => data.id);
  //         console.log(getDeposit);
  //       });
  //   }, []);
  const userRandomNumber = useSelector((state) => state.userRandomNumber);
  const getuserRandomNumber = userRandomNumber.userRandomNumber;

  const [getMessage, setgetMessage] = useState({
    message: "",
  });
  const handleMessageInput = (value, attr) => {
    setgetMessage({
      ...getMessage,
      message: value,
    });
  };
  const [loader, setloader] = useState(false);
  const modifyUserNumber = String(getuserRandomNumber);
  const handleSubmitMessage = (e) => {
    e.preventDefault();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: modifyUserNumber }),
    };
    fetch("http://test-email-example.herokuapp.com/", requestOptions)
      .then((response) =>
        response.json().then((data) => {
          console.log(data);
        })
      )
      .catch((error) => {
        console.log(error);
      });
    if (getMessage.message === "") {
      setgetMessage({
        message: "",
      });
    } else {
      setloader(true);
      firestore
        .collection("adminChatList")
        .get()
        .then((user) => {
          const getNewUser = user.docs.find(
            (newUser) => newUser.data().newUser === modifyUserNumber
          );
          if (getNewUser) {
            firestore
              .collection("customerMessages")
              .doc(modifyUserNumber)
              .collection("messages")

              .add({
                fromUser: modifyUserNumber,
                read: false,
                to: "admin",
                message: getMessage.message,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                delivered: true,
                deliveredTime: moment().format("LT"),
              })
              .then(() => {
                setloader(false);
                setgetMessage({
                  message: "",
                });
              });
          } else {
            firestore
              .collection("adminChatList")
              .add({
                newUser: modifyUserNumber,
                createdAt: moment().format("MMMM Do YYYY, h:mm:ss a"),
              })
              .then(() => {
                firestore
                  .collection("customerMessages")
                  .doc(modifyUserNumber)
                  .collection("messages")

                  .add({
                    fromUser: modifyUserNumber,
                    read: false,
                    to: "admin",
                    message: getMessage.message,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                    delivered: true,
                    deliveredTime: moment().format("LT"),
                  })
                  .then(() => {
                    setloader(false);
                    setgetMessage({
                      message: "",
                    });
                  });
              })
              .catch((error) => {
                setloader(false);
                alert("there was an error pls try again");
                setgetMessage({
                  message: "",
                });
              });
          }
        });
    }
  };
  const dispatch = useDispatch();
  const handleCloseMessageDiv = () => {
    dispatch({ type: "toggle_state", data: "none" });
  };
  return (
    <div
      className="chat__cover col-lg-4 col-md-8 col-sm-8 col-12"
      style={{ transition: "all .3s" }}
    >
      <div className="chat__component__overlay">
        <div className="chat__header">
          Treasure Growth Investment
          <span
            style={{ position: "absolute", left: "90%", cursor: "pointer" }}
          >
            <img
              src="images/cross.png"
              alt="close"
              onClick={handleCloseMessageDiv}
            />
          </span>
        </div>
        <div className="message__component">
          <RenderMessage />
        </div>
        <div className="input__message__div">
          <form className="input__message__div" onSubmit={handleSubmitMessage}>
            <input
              type="text"
              value={getMessage.message}
              className="input__chat"
              placeholder="Type your message..."
              onChange={(evt) =>
                handleMessageInput(evt.target.value, "message")
              }
            />
            <button className="chat__button">
              <img src={SendImage} alt="logo" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
